import { getProductRelationItems } from "./getProductRelationItems.js";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { isSubscriptionShapeBookClub, isSubscriptionShapeDigitalService, isSubscriptionShapeSeries, isSubscriptionShapeSubscription, } from "../../subscription-plan/selectors/isSubscriptionShape.js";
import { getSubscriptionType } from "./getSubscriptionType.js";
const SUBSCRIPTION_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.SUBSCRIPTION;
const SERIES_SUBSCRIPTION_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION;
const BOOK_CLUB_IDS = CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB;
export const getSubscriptionVariantGifts = (subscription) => {
    const subscriptionType = getSubscriptionType(subscription);
    const isSeries = isSubscriptionShapeSeries(subscriptionType);
    const isBookSubscription = isSubscriptionShapeSubscription(subscriptionType);
    const isBookClub = isSubscriptionShapeBookClub(subscriptionType);
    const isDigitalService = isSubscriptionShapeDigitalService(subscriptionType);
    if (isDigitalService)
        return { count: 0, items: [] };
    let giftIds;
    if (isSeries) {
        giftIds = SERIES_SUBSCRIPTION_IDS.VARIANT.GIFTS;
    }
    if (isBookSubscription) {
        giftIds = SUBSCRIPTION_IDS.VARIANT.GIFTS;
    }
    if (isBookClub) {
        giftIds = BOOK_CLUB_IDS.VARIANT.GIFTS;
    }
    if (!giftIds)
        throw new Error(`Unsupported subscription shape for gifts - Sku ${subscription?.sku}`);
    const giftConfigContent = getComponentContentById(subscription.components, giftIds.ID)?.chunks;
    if (!giftConfigContent || giftConfigContent.length === 0) {
        return { count: 0, items: [] };
    }
    const sections = giftConfigContent
        .map((chunk) => {
        return chunk.reduce((acc, { componentId: id, content }) => {
            if (id === giftIds.COUNT &&
                content?.__typename === "NumericContent") {
                return { ...acc, count: content.number };
            }
            if (id === giftIds.GIFTS &&
                content?.__typename === "ItemRelationsContent") {
                return { ...acc, items: getProductRelationItems(content) };
            }
            return acc;
        }, {
            count: 0,
            items: [],
        });
    })
        .filter((section) => section.count > 0 || section.items.length > 0);
    const count = sections.reduce((sum, section) => sum + section.count, 0);
    const items = sections.flatMap((section) => section.items);
    return {
        count,
        items,
        sections,
    };
};
